import { Stack, Typography } from '@mui/material';

import { RHFAutocomplete, RHFRichTextEditor, RHFTextField } from '@zeta-core';
import { useLocation } from 'react-router';

export const FormFields = ({
  entityConfig,
}: {
  entityConfig?: {
    toEntityType: string;
    toEntityID: string;
    toUserID: string;
    fromUserID: string;
    fromName: string;
    toName: string;
    partnerUserName?: string;
    partnerUserID?: string;
  };
}) => {
  const location = useLocation();

  const clientRegistered = location?.state?.clientData?.clientRegistered;
  const partnerClientRegistered = location?.state?.clientData?.partnerClientRegistered;

  const toOptions = [];
  if (clientRegistered) toOptions.push({ label: `${entityConfig?.toName}`, value: entityConfig?.toUserID, for: 'client' });
  if (partnerClientRegistered) toOptions.push({ label: `${entityConfig?.partnerUserName}`, value: entityConfig?.partnerUserID, for: 'partner' });

  return (
    <Stack>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Please enter the details below
      </Typography>

      <Stack spacing={2}>
        <RHFTextField name="from" label="From" disabled />
        {entityConfig?.toUserID && entityConfig?.partnerUserID ? (
          <RHFAutocomplete name="to" label="To" options={toOptions} />
        ) : (
          <RHFTextField name="to" label="To" disabled />
        )}
        <RHFTextField name="subject" label="Subject" />
        <RHFRichTextEditor name="message" label="Message" />
      </Stack>
    </Stack>
  );
};
